import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { OnboardingLayout } from '../components/onboarding/OnboardingLayout';
import { ProgressIndicator } from '../components/onboarding/ProgressIndicator';
import { WelcomeStep } from '../components/onboarding/WelcomeStep';
import { SportSelectionStep } from '../components/onboarding/SportSelectionStep';
import { LocationStep } from '../components/onboarding/LocationStep';
import { EmailVerificationStep } from '../components/onboarding/EmailVerificationStep';
import { HowItWorksModal } from '../components/onboarding/HowItWorksModal';
export const OnboardingPage = () => {
  const navigate = useNavigate();
  const [step, setStep] = useState(1);
  const [selectedSports, setSelectedSports] = useState<string[]>([]);
  const [location, setLocation] = useState('');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [email, setEmail] = useState('');
  const [isEmailSubmitted, setIsEmailSubmitted] = useState(false);
  const [verificationCode, setVerificationCode] = useState('');
  const [isVerified, setIsVerified] = useState(false);
  const totalSteps = 4;
  const handleSportSelection = (sport: string) => {
    if (selectedSports.includes(sport)) {
      setSelectedSports(selectedSports.filter(s => s !== sport));
    } else {
      setSelectedSports([...selectedSports, sport]);
    }
  };
  const handleLocationChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setLocation(e.target.value);
  };
  const handleEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setEmail(e.target.value);
  };
  const handleVerificationCodeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value.replace(/[^0-9]/g, '').slice(0, 6);
    setVerificationCode(value);
    // Auto-verify when 6 digits are entered
    if (value.length === 6) {
      setIsVerified(true);
    }
  };
  const handleVerifyEmail = () => {
    // In a real app, this would send an API request to send a verification code
    setIsEmailSubmitted(true);
  };
  const nextStep = () => {
    if (step < totalSteps) {
      setStep(step + 1);
    }
  };
  const prevStep = () => {
    if (step > 1) {
      setStep(step - 1);
    }
  };
  const completeOnboarding = () => {
    navigate('/app');
  };
  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
  };
  return <OnboardingLayout data-id="element-1106">
      {/* Progress indicator */}
      <ProgressIndicator currentStep={step} totalSteps={totalSteps} data-id="element-1107" />
      {/* Step content */}
      {step === 1 && <WelcomeStep onNextStep={nextStep} onOpenModal={toggleModal} data-id="element-1108" />}
      {step === 2 && <SportSelectionStep selectedSports={selectedSports} onSelectSport={handleSportSelection} onNextStep={nextStep} onPrevStep={prevStep} data-id="element-1109" />}
      {step === 3 && <LocationStep location={location} onLocationChange={handleLocationChange} onSelectLocation={setLocation} onNextStep={nextStep} onPrevStep={prevStep} data-id="element-1110" />}
      {step === 4 && <EmailVerificationStep email={email} verificationCode={verificationCode} isEmailSubmitted={isEmailSubmitted} isVerified={isVerified} onEmailChange={handleEmailChange} onVerificationCodeChange={handleVerificationCodeChange} onVerifyEmail={handleVerifyEmail} onChangeEmail={() => setIsEmailSubmitted(false)} onCompleteOnboarding={completeOnboarding} onPrevStep={prevStep} data-id="element-1111" />}
      {/* Modal */}
      <HowItWorksModal isOpen={isModalOpen} onClose={toggleModal} data-id="element-1112" />
    </OnboardingLayout>;
};